// extracted by mini-css-extract-plugin
module.exports = {"base":"SvgIcon__base__37J6d"};